import React, { useEffect, useState } from 'react'
import { useContext } from "react"
import { BlocksContext } from "../context/blocksContext"



export const Header = () => {
    const [swiper, setSwiper] = useState()
    const blocks = useContext(BlocksContext)

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + "/action/action.json")
            .then(res => res.json())
            .then((resp) => {
                setActionDate(resp.data)
            })
            .catch((err) => console.error("Ошибка подгрузки данных", err))
    }, [])

    const clickMenu = (e) => {
        e.preventDefault()
        let popup = e.currentTarget.getAttribute("href")

        if (blocks.blocks < 14) {
            blocks.setBlocks(14)
            setTimeout(() => {

                window.scrollTo({
                    top: document.querySelector("#" + popup).offsetTop,
                    behavior: "smooth"
                })

            }, 1400)

        } else {
            window.scrollTo({
                top: document.querySelector("#" + popup).offsetTop,
                behavior: "smooth"
            })
        }

        setMobileOpen(false)
    }

    useEffect(() => {
        if (swiper) {
            setTimeout(() => {
                swiper.slideNext()
            }, 30000)
        }
    }, [swiper])

    return (<React.Fragment>
        <div className="header plr">
            <div className="header_inner">
                <h1>
                    {/* &nbsp; - Мягкий перенос чтобы избежать висячего слова */}
                    ЖК ОЛИМП <br className='br_first' />Квартиры в&nbsp;Георгиевске <span className='whitespace-nowrap'>от 4,1 млн руб</span>
                </h1>
                <div className="head_inf">
                    0% рассрочка от застройщика
                </div>
                <div className="head_inf" style={{ marginTop: "15px" }}>
                    Скидка участникам СВО до&nbsp;4000 руб/кв.м.
                </div>
                <div className="header_button">
                    <a className="btn_main" href="#" onClick={(e) => { e.preventDefault(); Marquiz.showModal('66e2e565518bf90026c50892') }}>Получить подборку квартир</a>
                </div>
            </div>
        </div>
    </React.Fragment>
    )
}

export default Header